var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-link',{attrs:{"type":"primary","icon":"el-icon-edit-outline"},on:{"click":function($event){return _vm.handleEditManager(_vm.formData)}}}),_c('select-manager',{ref:"refSelectManager",on:{"handleSelect":_vm.handleSelectManager}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }